/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { AggregationMethodEnum } from "./AggregationMethodEnum";
import {
  AggregationMethodEnumFromJSON,
  AggregationMethodEnumFromJSONTyped,
  AggregationMethodEnumToJSON,
  AggregationMethodEnumToJSONTyped,
} from "./AggregationMethodEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface GroundWaterSubstanceConcentration
 */
export interface GroundWaterSubstanceConcentration {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  readonly simulation?: string;
  /**
   *
   */
  substance: string;
  /**
   *
   */
  readonly substanceId?: number;
  /**
   *
   */
  readonly substanceName?: string;
  /**
   *
   */
  initialConcentration: string;
  /**
   *
   */
  readonly initialConcentrationId?: number;
  /**
   *
   */
  readonly uid?: string;
  /**
   *
   */
  readonly id?: number;
  /**
   *
   */
  aggregationMethod: AggregationMethodEnum;
}

/**
 * Check if a given object implements the GroundWaterSubstanceConcentration interface.
 */
export function instanceOfGroundWaterSubstanceConcentration(
  value: object
): value is GroundWaterSubstanceConcentration {
  if (!("substance" in value) || value["substance"] === undefined) return false;
  if (
    (!("initialConcentration" in (value as Record<string, any>)) &&
      !("initial_concentration" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["initialConcentration"] === undefined &&
      (value as Record<string, any>)["initial_concentration"] === undefined)
  )
    return false;
  if (
    (!("aggregationMethod" in (value as Record<string, any>)) &&
      !("aggregation_method" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["aggregationMethod"] === undefined &&
      (value as Record<string, any>)["aggregation_method"] === undefined)
  )
    return false;
  return true;
}

export function GroundWaterSubstanceConcentrationFromJSON(
  json: any
): GroundWaterSubstanceConcentration {
  return GroundWaterSubstanceConcentrationFromJSONTyped(json, false);
}

export function GroundWaterSubstanceConcentrationFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): GroundWaterSubstanceConcentration {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    simulation: json["simulation"] == null ? undefined : json["simulation"],
    substance: json["substance"],
    substanceId: json["substance_id"] == null ? undefined : json["substance_id"],
    substanceName: json["substance_name"] == null ? undefined : json["substance_name"],
    initialConcentration: json["initial_concentration"],
    initialConcentrationId:
      json["initial_concentration_id"] == null ? undefined : json["initial_concentration_id"],
    uid: json["uid"] == null ? undefined : json["uid"],
    id: json["id"] == null ? undefined : json["id"],
    aggregationMethod: AggregationMethodEnumFromJSON(json["aggregation_method"]),
  };
}

export function GroundWaterSubstanceConcentrationToJSON(
  json: any
): GroundWaterSubstanceConcentration {
  return GroundWaterSubstanceConcentrationToJSONTyped(json, false);
}

export function GroundWaterSubstanceConcentrationToJSONTyped(
  value?: Omit<
    GroundWaterSubstanceConcentration,
    "url" | "simulation" | "substanceId" | "substanceName" | "initialConcentrationId" | "uid" | "id"
  > | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    substance: value["substance"],
    initial_concentration: value["initialConcentration"],
    aggregation_method: AggregationMethodEnumToJSON(value["aggregationMethod"]),
  };
}
